
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class vNavigation extends Vue {
  @Prop() open!: boolean;

  get moveNavigation() {
    if (this.open) {
      return {
        transform: "translate(210px, 0px)"
      };
    }
  }

  openNavigation() {
    this.$emit("openNavigation");
  }
  closeNavigation() {
    this.$emit("closeNavigation");
  }
  pinSidebar() {
    if ($("body").hasClass("menu-pin")) {
      $("body").removeClass("menu-pin");
      $('.footer').css('margin-left', 'auto');

    }
    else {
      $("body").addClass("menu-pin");
      $('.footer').css('margin-left', '280px');
    }
  }

  created() {
    $(document).off("click.pg.sidebar.data-api", '[data-toggle-pin="sidebar"]');
    $(document).off("click.pg.sidebar.data-api", '[data-toggle="sidebar"]');
  }
}
